// extracted by mini-css-extract-plugin
export var countApi = "search-module--count-api--1GN58";
export var countBox = "search-module--count-box--2M_ER";
export var countBoxLoading = "search-module--count-box-loading--KNv4V";
export var countBoxNumber = "search-module--count-box-number--TgXJZ";
export var countBoxTitle = "search-module--count-box-title--1MB_O";
export var countBoxes = "search-module--count-boxes--1-Hyv";
export var loading = "search-module--loading--ftUY3";
export var searchContainer = "search-module--search-container--1cBau";